import { createAxios } from "@msuite/katana";
import { auth } from "./_firebase";

const { ax } = createAxios(auth, "MenkeSuite");
export { ax };
